export default __webpack_public_path__ + "static/media/local2.aa6790e1.webp";